import React from "react";
import Solutions_Dash from "./Solutions_Dash";
import Solutions_Dash_Mobile from "./Solutions_Dash_mobile";
import { useIsMobile } from "./hooks/use-mobile";

const Solutions_Dash_Wrapper = () => {
  const isMobile = useIsMobile();

  return (
    <>
      {isMobile ? <Solutions_Dash_Mobile /> : <Solutions_Dash />}
    </>
  );
};

export default Solutions_Dash_Wrapper;